// 개발 환경 여부 확인 분기
const COOKIE_DOMAIN = window.location.hostname === 'localhost' ? undefined : '.kacelab.com';

/**
 * 쿠키 설정 함수
 * @param {string} name - 쿠키 이름
 * @param {string} value - 쿠키 값
 * @param {number} days - 쿠키 유효일 (기본 30일)
 * @param {string} domain - 도메인 (기본: 운영 도메인 또는 undefined)
 */
export const setCookie = (name, value, days = 30, domain = COOKIE_DOMAIN) => {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000); // days 만큼 쿠키 유효 시간 설정
  const expires = `expires=${d.toUTCString()}`;

  const isDev = window.location.hostname === 'localhost'; // 개발서버
  const isHttps = window.location.protocol === 'https:'; // 운영서버

  let cookieString = `${name}=${value};${expires};path=/`;

  if (!isDev && domain) {
    cookieString += `;domain=${domain}`;
    cookieString += isHttps ? ';SameSite=None;Secure' : ';SameSite=Lax';
  }

  document.cookie = cookieString;
  console.log('[쿠키 설정]', name, value, cookieString);
};

/**
 * 쿠키 가져오기 함수
 * @param {string} name - 가져올 쿠키 이름
 * @returns {string|null} - 쿠키 값 또는 null
 */
export const getCookie = (name) => {
  const prefix = name + '=';
  const list = document.cookie.split(';');
  for (let item of list) {
    item = item.trim();
    if (item.startsWith(prefix)) {
      return item.substring(prefix.length);
    }
  }
  return null;
};

/**
 * 쿠키 삭제 함수
 * @param {string} name - 삭제할 쿠키 이름
 * @param {string} domain - 삭제할 도메인 (기본 운영 도메인)
 */
export const removeCookie = (name, domain = COOKIE_DOMAIN) => {
  const expired = `;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;

  // 도메인 없이 우선 삭제 시도
  document.cookie = `${name}=${expired}`;

  const isDev = window.location.hostname === 'localhost';
  if (!isDev && domain) {
    // 운영 도메인 명시하여 삭제
    document.cookie = `${name}=${expired};domain=${domain}`;
  }

  console.log('[쿠키 삭제]', name);
};
